import React from 'react';
import styled from 'styled-components';
import { Text, IconButtonProps, IconButton } from '@oneaudi/unified-web-components';
import {
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_SPACE_FIXED_500,
  SYS_SPACE_FIXED_200,
  SYS_BREAKPOINT_SM,
  SYS_SPACE_FIXED_350,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_2_XL,
  SYS_SPACE_FIXED_1200,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_600,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_RELATIVE_XL,
  SYS_SPACE_FIXED_900,
} from '@oneaudi/unified-web-common';

import { dynamicStylingHelper, GetSafeColorDesignToken } from '@oneaudi/vtp-shared';

export const QuickFilters = styled.div`
  display: none;

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    display: block;
  }
`;

export const QuickFiltersWrapper = styled.div`
  --sidebar-width-lg: 256px;
  --sidebar-width-xl: 296px;
  --sidebar-width-2xl: 408px;
  --toolbar-height: 80px;
  --padding-top-md: 32px;
  --padding-bottom-md: calc(
    ${SYS_SPACE_FIXED_1200} + ${SYS_SPACE_FIXED_500} - ${SYS_SPACE_FIXED_500}
  );

  padding: 48px ${SYS_SPACE_FIXED_200}
    calc(${SYS_SPACE_FIXED_1200} + ${SYS_SPACE_FIXED_200} - ${SYS_SPACE_FIXED_500})
    ${SYS_SPACE_FIXED_200};

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    padding: 32px ${SYS_SPACE_FIXED_350}
      calc(${SYS_SPACE_FIXED_1200} + ${SYS_SPACE_FIXED_350} - ${SYS_SPACE_FIXED_500})
      ${SYS_SPACE_FIXED_350};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: var(--padding-top-md) ${SYS_SPACE_FIXED_500} var(--padding-bottom-md)
      ${SYS_SPACE_FIXED_500};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    min-width: var(--sidebar-width-lg);
    max-width: var(--sidebar-width-lg);

    // sticky behaviour
    position: sticky;
    top: var(--toolbar-height);
    // viewport minus toolbar, toolbar spacing and padding-bottom
    height: calc(100vh - var(--toolbar-height) - ${SYS_SPACE_RELATIVE_XL} - ${SYS_SPACE_FIXED_900});
    overflow-y: auto;
    margin-bottom: ${SYS_SPACE_FIXED_600};
    padding-bottom: ${SYS_SPACE_FIXED_500};
    padding-top: 0;
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    min-width: var(--sidebar-width-xl);
    max-width: var(--sidebar-width-xl);
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    min-width: var(--sidebar-width-2xl);
    max-width: var(--sidebar-width-2xl);
  }
`;

export const RenderedQuickFiltersWrapper = styled.div``;

export const SelectedFiltersHeadline = styled(Text)`
  ${dynamicStylingHelper('color: var(--Sem-Color-Forms-Foreground-Text-Caption, #666666)')};
  font-family: AudiType, sans-serif;
`;

export const QuickFiltersFooter = styled.div`
  display: flex;
  padding: ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_200};
  margin-top: 0;
  border-top: unset;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  gap: ${SYS_SPACE_FIXED_100};
  background: ${GetSafeColorDesignToken('QUICK_FILTERS_FOOTER')};
  backdrop-filter: blur(${GetSafeColorDesignToken('FILTER_OVERLAY_BLUR')});
  justify-content: center;
  align-items: center;

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    padding: ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_350};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    padding: ${SYS_SPACE_FIXED_150} ${SYS_SPACE_FIXED_500};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-top: 0;
    border-top: unset;
    box-shadow: unset;
    position: static;
    justify-content: center;
    padding: unset;
    background: unset;
  }
`;

export const QuickFilterResults = styled.span`
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    flex-direction: row;
    gap: 1ch;
  }
`;

export const StyledCloseButton = styled((props) => <IconButton {...props} />)<IconButtonProps>`
  position: fixed;
  right: ${dynamicStylingHelper('0', SYS_SPACE_FIXED_100)};
  top: ${dynamicStylingHelper('0', SYS_SPACE_FIXED_100)};
  border: none;

  button {
    border: none;
  }
`;
